export default __webpack_public_path__ + "static/media/try-again-button.d9b6e46c.svg";